"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BatteryStatusIcon;
var _material = require("@mui/material");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function BatteryStatusIcon({
  svgProps,
  ...rest
}) {
  const uniqueID = (0, _utils.generateUniqueId)();
  const color = (0, _utils.getColor)(rest);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.SvgIcon, {
    ...svgProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: uniqueID,
        y1: "100%",
        x2: "0%",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: `${rest.value}%`,
          stopColor: color
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          stopColor: "white"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: `url(#${uniqueID})`,
      stroke: "black",
      strokeWidth: "1",
      d: "M17,5v16c0,0.55-0.45,1-1,1H8c-0.55,0-1-0.45-1-1V5c0-0.55,0.45-1,1-1h2V2h4v2h2C16.55,4,17,4.45,17,5z"
    })]
  });
}